import { Touchpoint } from '../../../ScriptingEngineEnvironment';

export class CustomDropdownTouchpoint implements Touchpoint.CustomDropdown.ICustomDropdownTouchpoint {
    register(): void {
        // we currently do not extract any metadata about validation function registrations.
    }
}
